<template>
	<ErrorBoundary>
		<TestSiteWarning />
		<SiteNotification />
		<NuxtLayout>
			<NuxtPage />
			<ModalError />
			<ModalLoading />
			<AlertsToast />
		</NuxtLayout>
		<CookiesNoticePopup />
	</ErrorBoundary>
</template>

<script setup>
	import { SHOW_ERROR } from "~/assets/events/errors.js"

	const { $messages, $userService, $eventBus } = useNuxtApp()
	const { t } = useI18n()
	$messages.$init(t)

	const authStore = useAuthStore()
	const isAuthenticated = authStore.isAuthenticated
	const fetchUserSummaryOnRefresh = () => {
		if (isAuthenticated && !authStore.isTokenExpired()) {
			$userService.$getUserSummary()
		}
	}

	//detectTranslator: Shows a warning popup if the user is using a browser translator
	let translationObserver = ref(null)
	const detectTranslator = () => {
		const showWarningIfNotEnglish = (currentLang) => {
			if (currentLang.indexOf("en") <= 0) {
				$eventBus.$emit(SHOW_ERROR, {
					titleText: `${$messages.$t("detectedTranslatorTitle")}`,
					bodyText: `${$messages.$t("detectedTranslatorBody")}`,
				})
			}
		}

		const currentLang = document.documentElement.lang
		showWarningIfNotEnglish(currentLang)

		translationObserver.value = new MutationObserver(() => {
			const newLang = document.documentElement.lang
			showWarningIfNotEnglish(newLang)
		})

		translationObserver.value.observe(document.documentElement, {
			attributes: true,
			attributeFilter: ["lang"],
		})
	}

	//testSentry: method attached to the window for testing Sentry integrations
	const testSentry = () => {
		const msg =
			"This is a console error log for testing. Sentry is working as expected. " +
			"This is a console error log for testing. Sentry is working as expected. " +
			"This is a console error log for testing. Sentry is working as expected. " +
			"This is a console error log for testing. Sentry is working as expected."
		console.error(msg)
		undefinedFuncForTesting()
	}

	onMounted(() => {
		fetchUserSummaryOnRefresh()
		detectTranslator()
		window.testSentry = testSentry
	})

	onUnmounted(() => {
		if (translationObserver.value) translationObserver.value.disconnect()
	})
</script>
